/* istanbul ignore file -- @preserve */
// TODO: add unit tests
import { currentEnvironment } from "@porsche-customer/slfinrtl-environment"
import { getPcw20Domain } from "@slfinrtl/feature-config"

export function getPcw20Host(dealershipId: string): string | undefined {
	const env = currentEnvironment()
	return getPcw20Domain(dealershipId, env === "local" ? "dev" : env)
}

export function isUsingPcw20Website(dealershipId: string) {
	return getPcw20Host(dealershipId) !== undefined
}
